<template>
    <div class="resource-detail">
        <el-form ref="workTimeForm" size="mini" label-width="120px" class="resource-form">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="经度" prop="longitude">
                        <el-input disabled v-model="workTimeDetail.longitude"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="纬度" prop="dimension">
                        <el-input disabled v-model="workTimeDetail.dimension"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <WorkTimeMap  @getMapsData="getMapsData" :longitude="workTimeDetail.longitude" :latitude="workTimeDetail.dimension" :isNewData="isNewData"></WorkTimeMap>
            </el-form-item>
            <el-form-item>
                <el-col :span="10">
                    <el-form-item label="选取地址">
                        <el-input  v-model="workTimeDetail.chooseLocationAddr"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="定位范围(米)">
                        <el-input  v-model="workTimeDetail.locationRange"></el-input>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item style="float: right;">
                <el-button type="primary" @click="handleWorkTimeSave">保存</el-button>
                <el-button @click="handleCancel">取消</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>
<script>
    import mixinsNav from '@/mixins/mixins-nav';
    import { cloneDeep } from 'lodash';
    // import { updateWorkTime } from '@/data-model';
    import WorkTimeMap from '@/pages/office/workTime/WorkTimeDetail/WorkTimeMap';
    export default {
        name: 'WorkTimeDetail',
        mixins: [ mixinsNav ],
        components: {
            WorkTimeMap
        },
        data () {
            return {
                workTimeDetail: {
                    id: '',
                    dimension: '',
                    longitude: '',
                    chooseLocationAddr: '',
                    nearestPOI: '',
                    nearestJunction: '',
                    nearestRoad: '',
                    address: '',
                    locationRange: ''
                }
            };
        },
        created () {
            this._initPage();
        },
        props: {
            locationInfo: {
                type: Object
            },
            isNewData: {
                type: Number
            }
        },
        methods: {
            async _initPage () {
                if (this.locationInfo) {
                    this.workTimeDetail = cloneDeep(this.locationInfo);
                }
            },
            handleWorkTimeSave () {
                this.workTimeDetail.id = this.generateUUID();
                this.$emit('configLocationArray', this.workTimeDetail);
            },
            handleCancel (flg) {
                this.$emit('hideSidebox', flg);
            },
            getMapsData (data) {
                this.workTimeDetail.dimension = data.latitude;
                this.workTimeDetail.longitude = data.longitude;
                this.workTimeDetail.chooseLocationAddr = data.nearestPOI;
                this.workTimeDetail.nearestPOI = data.nearestPOI;
                this.workTimeDetail.nearestRoad = data.nearestRoad;
                this.workTimeDetail.nearestJunction = data.nearestJunction;
                this.workTimeDetail.address = data.address;
                this.workTimeDetail.locationRange = '500';
                this.workTimeDetail = cloneDeep(this.workTimeDetail);
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            }
        }
    };
</script>

<style lang="less">
    .resource-detail {
        width: 100%;
        height: 100%;
        overflow: auto;
        .resource-form {
            width: 95%;
            padding-bottom: 80px;
        }
        .el-radio+.el-radio {
            margin-left: 5px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/FieldProps/LocationConfig.vue